<!--
 * @Author: M.D.
 * @Date: 2019-12-24 13:09:07
 * @LastEditors  : M.D.
 * @Description: 商品列表（首页）（仅展示，无操作）
 * @Remarks:
 -->
<template>
  <div class="product-list">
    <ul class="product-list-ul">
      <li
        v-for="(i, idx) in dataList"
        :key="idx"
        class="prd-li-4"
        :style="`width: ${wpercent == 5 ? '20%' : '25%'}`"
      >
        <div class="prd-inner-w bShadow-10" @click="goGdsDetail(i)">
          <div class="prd-img-w">
            <img
              :src="tImgUrl(i.image.split(',')[0])"
              alt=""
              :onerror="errImgDefault"
            />
            <img
              v-if="ifActive(i)"
              class="active-icon"
              src="~@/assets/image/active.png"
            />
          </div>
          <div class="prd-name">{{ i.name }}</div>
          <div class="prd_price">
            <div class="prd-rate">{{ goodInfo(i) }}</div>
            <div class="prd-price-info">
              <div class="prd-p-orig" v-if="i.type == 5">
                <span class="unit" style="display: block">{{
                  i.partnerName
                }}</span>
              </div>
              <div class="prd-p-orig" v-else>
                <span class="unit" v-if="i.isOnPay === 1">￥</span
                ><span class="unit">{{
                  i.isOnPay !== 1 ? '价格面议' : getFinalPrice(i)
                }}</span>
              </div>
              <div class="prd-p-disc" v-if="i.discountPrice !== -1">
                <span class="unit">￥</span
                ><span class="num">{{ i.price }}</span>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!--      <div class="need-help" v-if="showOther">-->
      <!--        <img src="@/assets/image/qaq.png" alt="">-->
      <!--      </div>-->
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      default: () => [],
      type: Array,
    },
    showOther: {
      default: false,
      type: Boolean,
    },
    wpercent: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {},
  methods: {
    goGdsDetail(i) {
      this.$router.push({ name: 'productDetail', params: { prodId: i.id } })
    },
    ifActive(i) {
      return i.videoUrl
    },
  },
  components: {},
}
</script>

<style lang="stylus">
.product-list {
  .product-list-ul {
    display: flex;
    flex-wrap: wrap;
    position: relative;

    .need-help {
      position: absolute;
      right: -40px;
      bottom: -40px;
      height: 100px;
      width: 100px;
      font-size: 0;

      img {
        display: inline-block;
        height: 100%;
        width: 100%;
      }
    }

    .prd-li-4 {
      box-sizing: border-box;
      padding: 20px 20px;
      width: 25%;
      overflow: hidden;

      .prd-inner-w {
        background-color: #ffffff;
        box-shadow: 0px 0px 10px 0px rgba(174, 85, 0, 0.2);
        border-radius: 8px;
        border: 1px solid #eeeeee;

        .prd-img-w {
          width: 270px;
          height: 200px;
          background-color: #ffffff;

          img {
            width: 270px;
            height: 200px;
            object-fit: cover;
          }

          .active-icon {
            width: 1.4rem;
            height: 1.4rem;
            position: absolute;
            margin: auto;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 99;
          }
        }

        .prd-name {
          text-align: left;
          height: 59px;
          line-height: 59px;
          padding-left: 11px;
          font-size: 20px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #333333;
        }

        .prd_price {
          display: flex;
          height: 40px;
          padding: 0 11px 0 11px;
          justify-content: space-between;

          .prd-rate {
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #999999;
          
             margin-top:8px;
             height: 16px;
          }

          .prd-price-info {
            &>div {
              display: inline-block;
            }

            .prd-p-orig {
              color: orange-color;
              font-size: 24px;
              max-width: 100%;

              .unit {
                word-break: break-all;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                font-size: 24px;
              }
            }

            .prd-p-disc {
              padding-left: 20px;
              color: #999999;
              text-decoration: line-through;

              .unit {
                font-size: 18px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
